import React, { useCallback } from 'react';
import { Iframe } from '../../../../components/layer/Iframe';
import { readFinance } from '../../../utils/sessionStorage';
import { getAozProductsFromSession } from '../../../utils/aozSessionStorage';
export const getSummaryOnePointFive = (financingStateResponse) => {
    if (!financingStateResponse) {
        return {};
    }
    const { Response = {} } = financingStateResponse;
    const { Result } = Response;
    if (Result) {
        let onePointFive;
        if (Array.isArray(Result)) {
            onePointFive = Result.find((result) => result['@FormatVersion'] === '1.5');
        }
        else {
            onePointFive = Result;
        }
        if (onePointFive && onePointFive.Summaries && onePointFive.Summaries.Summary) {
            return onePointFive.Summaries.Summary;
        }
        return {};
    }
    return {};
};
export function usePostData(vehicle, dataProfile, vehicleRaw) {
    var _a, _b, _c, _d;
    const skuItems = (_a = vehicleRaw === null || vehicleRaw === void 0 ? void 0 : vehicleRaw.detail) === null || _a === void 0 ? void 0 : _a.skuItems;
    const sessionRes = vehicle ? ((_b = readFinance(vehicle.type)) !== null && _b !== void 0 ? _b : {}) : {};
    const financing = dataProfile !== 'no-finance-data'
        ? getSummaryOnePointFive((_d = (_c = sessionRes === null || sessionRes === void 0 ? void 0 : sessionRes.financing) === null || _c === void 0 ? void 0 : _c[vehicle === null || vehicle === void 0 ? void 0 : vehicle.id]) === null || _d === void 0 ? void 0 : _d.financeResponseData)
        : sessionRes;
    const products = vehicle ? getAozProductsFromSession(vehicle) : [];
    const dealerIds = [];
    return JSON.stringify([
        { aoz: products },
        { audicode: vehicle === null || vehicle === void 0 ? void 0 : vehicle.audiCode },
        { financingData: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.financing) ? financing : undefined },
        { vehicleData: vehicle },
        { dealerFilterIds: dealerIds },
        { skuItems },
    ]);
}
export const PostFormV2 = ({ link, postData, }) => {
    const formRef = useCallback((form) => {
        if (form) {
            form.submit();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { action: link.url, id: "tile-post-form", target: "cta-iframe", method: "post", hidden: true, ref: formRef },
            React.createElement("input", { type: "hidden", name: "inquiry_json_data", value: postData })),
        React.createElement(Iframe, { src: "", originUrl: link.url })));
};
